import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "schedule-bus" }
const _hoisted_2 = { class: "flex flex-wrap items-center sm:justify-between" }
const _hoisted_3 = { class: "flex items-center w-full sm:flex-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal w-2/4 sm:w-max" }, "Penjadwalan", -1)
const _hoisted_5 = { class: "justify-end w-full sm:w-max" }
const _hoisted_6 = { class: "flex mt-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-sort text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-black font-semibold text-sm text-center" }, "Urutkan", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-calendar text-base cursor-pointer text-black mr-1",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_10 = { class: "text-black font-semibold text-sm text-center" }
const _hoisted_11 = {
  key: 0,
  class: "flex w-full justify-center py-5"
}
const _hoisted_12 = { class: "sm:flex justify-between items-center" }
const _hoisted_13 = { class: "detail-category border-right-grey-lighten-3 flex-1 px-1 md:px-3" }
const _hoisted_14 = { class: "font-bold break-all" }
const _hoisted_15 = { class: "break-words color-blue-grey-darken-1 font-semibold" }
const _hoisted_16 = { class: "flex mt-2" }
const _hoisted_17 = { class: "pr-2 md:pr-4 flex items-center" }
const _hoisted_18 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3",
  style: {"border":"1px solid #43A047"}
}
const _hoisted_19 = { class: "color-green-darken-1 text-xs sm:text-sm" }
const _hoisted_20 = { class: "pr-2 md:pr-4 flex items-center" }
const _hoisted_21 = {
  class: "rounded-md background-grey-lighten-5 py-1 px-3",
  style: {"border":"1px solid #546E7A"}
}
const _hoisted_22 = { class: "color-blue-grey-darken-1 text-xs sm:text-sm" }
const _hoisted_23 = { class: "flex sm:block items-center px-1 sm:px-3 mt-3 sm:mt-0 md:px-6" }
const _hoisted_24 = { class: "flex items-center sm:mb-5" }
const _hoisted_25 = { class: "ml-3 sm:ml-0" }
const _hoisted_26 = { class: "p-col-12 block" }
const _hoisted_27 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ScheduleBusForm = _resolveComponent("ScheduleBusForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Jadwal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary w-2/4 sm:w-max"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.searchInput,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchInput = $event)),
              onKeypress: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.searchChange(_ctx.searchInput)), ["enter"])),
              placeholder: "Cari Disini ...",
              type: _ctx.$enumBase.input.text,
              icon: _ctx.$icon.svg.searchEva,
              class: "w-full content-center mt-5 sm:mt-0"
            }, null, 8, ["modelValue", "type", "icon"])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "filterChips",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDropDown($event, null, 'sort')))
          }, [
            _hoisted_7,
            _hoisted_8
          ]),
          _createVNode("div", {
            class: "filterChips",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDropDown($event, null, 'filterCalendar')))
          }, [
            _hoisted_9,
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.sendDateFilter.length > 1 ? `${_ctx.moment(_ctx.sendDateFilter[0]).format('DD/MM/YYYY')} - ${_ctx.moment(_ctx.sendDateFilter[1]).format('DD/MM/YYYY')}` : 'Tanggal'), 1)
          ]),
          (_ctx.$store.state.device.width < 640)
            ? (_openBlock(), _createBlock(_component_SelectButton, {
                key: 0,
                class: "selectScheduleBus scheduleBusSmall select-on",
                modelValue: _ctx.selectValue,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectValue = $event)),
                options: _ctx.selectOption,
                optionValue: "value",
                optionLabel: "name",
                multiple: ""
              }, null, 8, ["modelValue", "options"]))
            : (_openBlock(), _createBlock(_component_SelectButton, {
                key: 1,
                class: "selectScheduleBus select-on",
                modelValue: _ctx.selectValue,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectValue = $event)),
                options: _ctx.selectOption,
                optionValue: "value",
                optionLabel: "name",
                multiple: ""
              }, null, 8, ["modelValue", "options"]))
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.dataSource.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("h5", null, _toDisplayString(`Jadwal bus untuk tanggal ${_ctx.moment(_ctx.sendDateFilter[0]).format('DD/MM/YYYY')} - ${_ctx.moment(_ctx.sendDateFilter[1]).format('DD/MM/YYYY')} belum tersedia`), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSource, (item, index) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: ["card-no-shadow card-item-category mb-4", _ctx.backGroundCard(item).nameClass],
            key: index
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("h5", _hoisted_14, _toDisplayString(item.KodeJadwal), 1),
                  _createVNode("span", _hoisted_15, _toDisplayString(_ctx.moment(item.TanggalAktif).format("DD MMMM YYYY")), 1),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("p", _hoisted_19, _toDisplayString(`RIT ${item.Rit}`), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("p", _hoisted_22, _toDisplayString(item.TipeBus.Kode), 1)
                      ])
                    ]),
                    _createVNode("div", {
                      class: "pr-2 md:pr-4 flex items-center text-xs sm:text-sm",
                      innerHTML: _ctx.backGroundCard(item).viewText
                    }, null, 8, ["innerHTML"])
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_InputSwitch, {
                      class: "switch-og mr-4",
                      disabled: !_ctx.route.meta.permission.update,
                      modelValue: item.IsActive,
                      "onUpdate:modelValue": ($event: any) => (item.IsActive = $event),
                      onChange: ($event: any) => (_ctx.changeIsActive(item))
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]),
                    (_ctx.route.meta.permission.update)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                          "aria:haspopup": "true",
                          "aria-controls": "overlay_panel",
                          onClick: ($event: any) => (_ctx.showDropDown($event, item, null))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("p", {
                      class: "text-xs sm:text-sm color-primary font-semibold cursor-pointer text-center",
                      onClick: ($event: any) => (_ctx.detailData(item.Id))
                    }, " Lihat Detail Rute ", 8, ["onClick"])
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      footer: _withCtx(() => [
        (_ctx.dataSource.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filter.top,
              totalRecords: _ctx.filter.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          copy: false,
          del: false,
          edit: _ctx.route.meta.permission.update,
          onCopy: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyData(_ctx.dataForm))),
          onDel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["edit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "sortOp",
      id: "sort_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortingOption, (data) => {
          return (_openBlock(), _createBlock("div", {
            class: "p-field-radiobutton mb-2",
            key: data.key,
            onChange: ($event: any) => (_ctx.changeSorting(data.value))
          }, [
            _createVNode(_component_RadioButton, {
              id: data.key,
              class: "mr-2 radioScheduleBus",
              value: data.value,
              modelValue: _ctx.sortingValue,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortingValue = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: data.key
            }, _toDisplayString(data.name), 9, ["for"])
          ], 40, ["onChange"]))
        }), 128))
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "filterCal",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_26, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: "range"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_27, [
            (_ctx.dateFilter.length > 1)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            (_ctx.sendDateFilter !== null)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearFilter()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ScheduleBusForm, {
          inAction: _ctx.inActionForm,
          data: _ctx.dataForm,
          onReloadData: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getDataSource())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["inAction", "data", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}